module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border heading-cart clearfix"
  }, [_c('div', {
    staticClass: "clearfix pull-left col-md-8"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Sticky")]), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('span', {
    staticClass: "text-danger animated flash config-notif"
  }, [_vm._v("\n\t\t\t\t\t\tImported config from " + _vm._s(_vm.selectedBucketNameToImportConfig) + " Bucket. Click save to use the config.\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-left clearfix import col-md-1 text-center"
  }, [_c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    model: {
      value: (_vm.stickyConfig.isEnabled),
      callback: function($$v) {
        _vm.$set(_vm.stickyConfig, "isEnabled", $$v)
      },
      expression: "stickyConfig.isEnabled"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right clearfix import col-md-3"
  }, [_c('div', {
    staticClass: "col-md-9 text-right"
  }, [_c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectedBucketNameToImportConfig),
      expression: "!selectedBucketNameToImportConfig"
    }],
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.selectBucketModule
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "title": 'Import Config'
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\t\tImport Config "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.bucketListForModuleConfig), function(bucket, index) {
    return _c('el-dropdown-item', {
      attrs: {
        "command": index
      }
    }, [_vm._v(_vm._s(bucket.bucketName))])
  }), 1)], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedBucketNameToImportConfig),
      expression: "selectedBucketNameToImportConfig"
    }],
    staticClass: "el-button el-button--danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSelectedModuleConfig()
      }
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 no-padding"
  }, [_c('button', {
    staticClass: "el-button el-button--success",
    on: {
      "click": function($event) {
        return _vm.saveAndPublishAxtSticky()
      }
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.stickyConfigsList,
        "stripe": "",
        "height": "400"
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "layout",
        "sortable": "",
        "filters": _vm.filterList,
        "filter-method": _vm.layoutFilterHandler,
        "label": "Layout"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "alias_name",
        "label": "Ad Spot"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Start Point"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.startPoint ? props.row.startPoint : '-') + "\n\t\t\t\t\t\t\t")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "End Point"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.endPoint ? props.row.endPoint : '-') + "\n\t\t\t\t\t\t\t")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Timer(sec)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(props.row.timer > 0 ? props.row.timer : '-') + "\n\t\t\t\t\t\t\t")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Edit",
        "width": "50"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_c('button', {
            staticClass: "el-button btn-rounded el-button--success edit",
            on: {
              "click": function($event) {
                return _vm.editStickyConfig(props.row)
              }
            }
          }, [_c('i', {
            staticClass: "ti-pencil"
          })])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Delete",
        "width": "60"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_c('button', {
            staticClass: "el-button btn-rounded el-button--danger edit",
            on: {
              "click": function($event) {
                return _vm.deleteStickyUnitConfig(props.row)
              }
            }
          }, [_c('i', {
            staticClass: "ti-close"
          })])]
        }
      }])
    })], 1)], _vm._v(" "), _c('form', {
      staticClass: "form",
      attrs: {
        "method": "post"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.addStickyUnitConfig($event)
        }
      }
    }, [_c('div', {
      staticClass: "row clearfix"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "Select a Layout"
      },
      on: {
        "change": _vm.getAdSpots
      },
      model: {
        value: (_vm.stickyUnitConfig.layout),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "layout", $$v)
        },
        expression: "stickyUnitConfig.layout"
      }
    }, _vm._l((_vm.layoutsList), function(layout) {
      return _c('el-option', {
        key: layout.id,
        attrs: {
          "label": layout.layout_name,
          "value": layout.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("Main Selector(Ad Spot)")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "Select a AdSpot"
      },
      model: {
        value: (_vm.stickyUnitConfig.layoutAdSpots),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "layoutAdSpots", $$v)
        },
        expression: "stickyUnitConfig.layoutAdSpots"
      }
    }, _vm._l((_vm.layoutAdSpotsList), function(adSpot) {
      return _c('el-option', {
        key: adSpot.id,
        attrs: {
          "label": adSpot.adSpot,
          "value": adSpot.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("Timer(sec)")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "Timer",
        "type": "number",
        "value": "1",
        "min": "0",
        "max": "600"
      },
      model: {
        value: (_vm.stickyUnitConfig.timer),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "timer", $$v)
        },
        expression: "stickyUnitConfig.timer"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 m-t-15"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("Start Point")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "Start-point"
      },
      model: {
        value: (_vm.stickyUnitConfig.startPoint),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "startPoint", $$v)
        },
        expression: "stickyUnitConfig.startPoint"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 m-t-15"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("End Point")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "End-point"
      },
      model: {
        value: (_vm.stickyUnitConfig.endPoint),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "endPoint", $$v)
        },
        expression: "stickyUnitConfig.endPoint"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 m-t-15"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("More CSS")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "CSS to fix the ad unit"
      },
      model: {
        value: (_vm.stickyUnitConfig.moreCSS),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "moreCSS", $$v)
        },
        expression: "stickyUnitConfig.moreCSS"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 m-t-15"
    }, [_c('p', {
      staticClass: "form-label"
    }, [_vm._v("Top")]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "Top value to avoid header overlap"
      },
      model: {
        value: (_vm.stickyUnitConfig.top),
        callback: function($$v) {
          _vm.$set(_vm.stickyUnitConfig, "top", $$v)
        },
        expression: "stickyUnitConfig.top"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 m-t-15 text-right"
    }, [_c('button', {
      staticClass: "el-button el-button--success",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v(_vm._s(_vm.stickyUnitConfig.editId ? 'Update' : 'Save'))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stickyUnitConfig.editId),
        expression: "stickyUnitConfig.editId"
      }],
      staticClass: "el-button el-button--danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.clearForm()
        }
      }
    }, [_vm._v("Clear")])])])])
  ], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f97f17f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/axt/ConfigStickyTemplate.vue
// module id = 707
// module chunks = 2